module.exports = __webpack_public_path__ + "img/mp-solution-bg-5.73bfb1f4.jpg";